<template>
  <MaterialCard
    color="green"
    full-width
  >
    <table
      class="v-table v-data-table theme--light"
    >
      <thead>
        <tr>
          <th
            v-for="header in headers"
            :key="header.value"
            :style="{'width': header.value === 'typeName' ? `${10 + maxLevel * 1.1}rem` : 'auto'}"
          >
            <span
              class="subheading font-weight-light text--darken-3"
            >
              {{ header.text }}
            </span>
          </th>
        </tr>
      </thead>

      <transition-group
        name="table"
        tag="tbody"
      >
        <tr
          v-for="item in flatGroups"
          :key="item.id"
          :active="item.id === selected.id"
          class="table-row"
          @click="$emit('selected', item)"
        >
          <td class="pa-0">
            <div
              class="straight"
              :style="getRowStyles(item.level)"
            >
              <div
                v-if="item.level"
              >
                <v-btn
                  icon
                  class="ma-0"
                  :disabled="!item.hasChildren"
                  @click.stop="toggleExpandedIds(item.id)"
                >
                  <v-icon v-if="item.hasChildren">
                    {{ expandedIds.includes(item.id) ? 'mdi-minus' : 'mdi-plus' }}
                  </v-icon>
                </v-btn>
              </div>
              <div
                class="straight"
              >
                <v-icon class="mr-1">
                  {{ item.icon }}
                </v-icon>
                {{ item.typeName }}
              </div>
            </div>
          </td>
          <td>
            {{ item.name }}
          </td>
          <td style="text-align: center;">
            {{ item.representativeName }}
          </td>
          <td style="text-align: center;">
            {{ item.sensorsRest }}
          </td>
        </tr>
      </transition-group>
    </table>
  </MaterialCard>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'GroupTable',
  props: {
    selected: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    headers: [
      { sortable: false, text: '階層', value: 'typeName', align: 'center' },
      { sortable: false, text: 'グループ名', value: 'name', align: 'center' },
      { sortable: false, text: '担当', value: 'manager', align: 'center' },
      { sortable: false, text: 'センサー残', value: 'sensorsRest', align: 'center' }
    ]
  }),
  computed: {
    ...mapState('groups', ['group', 'expandedIds', 'maxLevel']),
    flatGroups () {
      if (!Object.keys(this.group).length) return []

      const groups = []
      const getThem = e => e.forEach(_group => {
        const { children, ...others } = _group
        groups.push({ ...others, hasChildren: children.length })
        if (this.expandedIds.includes(_group.id)) {
          getThem(_group.children)
        }
      })
      getThem([this.group])
      return groups
    }
  },
  methods: {
    ...mapMutations('groups', ['toggleExpandedIds']),
    getRowStyles (level) {
      if (!level) {
        return {
          'padding-left': '8px'
        }
      }
      return {
        'margin-left': `${(level * 1.2) - 0.5}rem`,
        'border-left': `3px solid ${this.calculateColor(level)}`
      }
    },
    calculateColor (level) {
      level--
      return `rgb(${level * 30}, ${level * 50}, ${255 - level * 60})`
    }
  }
}
</script>

<style lang="scss" scoped>
.straight {
  display: flex;
  align-items: center;
}
// List transitions
.table {
  &-row {
    transition: all .2s ease-in-out;
  }

  &-leave-active {
    transition: none !important;
    position: absolute;
  }

  &-enter, &-leave-to {
    transform: translateX(-20px);
    opacity: 0;
  }
}
</style>
